import { tv } from 'tailwind-variants';

export const baseControlStyles = tv({
	slots: {
		base: 'flex flex-col gap-1 px-[2px]'
	}
});

export const fieldLabelStyles = tv({
	base: 'block w-fit cursor-default text-xs font-medium text-gray-600'
});

export const fieldMessageStyles = tv({
	base: 'text-xs',
	variants: {
		intent: {
			description: 'text-gray-500',
			error: 'flex items-center gap-1 text-red-600 forced-colors:text-[Mark]',
			warning: 'text-yellow-600 forced-colors:text-[Mark]'
		}
	}
});
